import { Indicator } from '../../../Common/Charts/Indicator';
import useIndicatorChart from './hooks/useIndicatorChart';

export const IndicatorValue = () => {
    const { value } = useIndicatorChart();

    return (
        <Indicator
            title={`Índice de Eficácia - Valor`}
            indicatorValue={value}
        />
    );
};
